module.exports = __webpack_public_path__ + "media/shared/recording-success-749f838c.png";